/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Storage_LabelInputs */

const en_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage Location`)
};

const fr_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement de stockage`)
};

const de_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagerort`)
};

const it_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione di archiviazione`)
};

const ru_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Место хранения`)
};

const es_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación de almacenamiento`)
};

const zh_cn2_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存储位置`)
};

const ja_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管場所`)
};

const hi_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रखने की जगह`)
};

const pt_pt2_iconik_publish_storage_label = /** @type {(inputs: Iconik_Publish_Storage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local de armazenamento`)
};

/**
* | output |
* | --- |
* | "Storage Location" |
*
* @param {Iconik_Publish_Storage_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_storage_label = /** @type {((inputs?: Iconik_Publish_Storage_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Storage_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_storage_label(inputs)
	if (locale === "de") return de_iconik_publish_storage_label(inputs)
	if (locale === "it") return it_iconik_publish_storage_label(inputs)
	if (locale === "ru") return ru_iconik_publish_storage_label(inputs)
	if (locale === "es") return es_iconik_publish_storage_label(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_storage_label(inputs)
	if (locale === "ja") return ja_iconik_publish_storage_label(inputs)
	if (locale === "hi") return hi_iconik_publish_storage_label(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_storage_label(inputs)
	return en_iconik_publish_storage_label(inputs)
});